import { RegionShared } from "@1games-ru/region-shared";
import { useLayoutEffect, useState } from "react";
import { useDispatch } from "react-redux";
import rpc from "@1games-ru/rage-rpc";
import { DeviceEnum } from "@/domains/business/constants/deviceEnum";
import { clearSlice, setDevice } from "@/domains/business/slice";
import { setIsShow } from "@/domains/pc/slice";

export default function useShowPс() {
  const dispatch = useDispatch();
  const [businessId, setBusinessId] = useState<number | null>(null);

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Business.BusinessOfficePcShow,
      async (state: typeof RegionShared.Cef.Requests.BusinessShowOfficePcRequest) => {
        dispatch(setDevice(DeviceEnum.PC));
        dispatch(setIsShow(true));
        setBusinessId(state.businessId);
      },
    );

    rpc.register(RegionShared.Cef.Events.Business.BusinessOfficePcHide, async () => {
      dispatch(setDevice(null));
      dispatch(setIsShow(false));
      dispatch(clearSlice("saveInfo"));
      setBusinessId(null);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Business.BusinessOfficePcShow);
      rpc.unregister(RegionShared.Cef.Events.Business.BusinessOfficePcHide);
      setBusinessId(null);
    };
  }, [dispatch]);

  return { businessId };
}
